import script from "./VcfsConfirmPaymentsPopUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./VcfsConfirmPaymentsPopUp.vue?vue&type=script&setup=true&lang=ts"

import "./VcfsConfirmPaymentsPopUp.vue?vue&type=style&index=0&id=4f5707c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f5707c8"]])

export default __exports__